const baseUrl = '/api-cms'
//  const baseUrl = 'www.office.jinmajia.com'
export default baseUrl



// WEBPACK FOOTER //
// ./src/config/baseUrl.js